var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.77,
    height: 10.77,
    viewBox: "0 0 10.77 10.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1791EA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.386 10.27A4.89 4.89 0 01.5 5.387 4.89 4.89 0 015.386.5a4.89 4.89 0 014.885 4.886 4.89 4.89 0 01-4.885 4.885zm-2.24-4.602L4.678 7.2l2.947-2.946-.093-.093-2.5 2.5-.354.353-.353-.353-1.086-1.086-.093.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.386 1a4.385 4.385 0 100 8.77 4.385 4.385 0 000-8.77m-.708 6.79a.282.282 0 01-.2-.083L2.64 5.868a.283.283 0 010-.4l.4-.4a.282.282 0 01.4 0l1.24 1.239 2.653-2.653a.282.282 0 01.4 0l.4.4c.11.11.11.29 0 .4L4.878 7.707a.282.282 0 01-.2.083M5.386 0a5.391 5.391 0 015.385 5.386 5.391 5.391 0 01-5.385 5.385A5.391 5.391 0 010 5.386 5.391 5.391 0 015.386 0z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a664a727.svg";
export { ForwardRef as ReactComponent };